import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const NotesInput = () => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("notes")}
      placeholder={t("notesPlaceholder")}
      id="notes"
      type="text"
      autoComplete="notes"
      required={false}
      helperText={null}
      multiline={true}
    />
  );
};
export default NotesInput;